<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px">
              {{ $t("fixed-point-network-hfp-lfp-1-3") }}
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else>
          {{ $t("fixed-point-network-hfp-lfp-1-3") }}
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR section="section1002" field="FIX_NAM" :label="$t('fixed-point-name')">
                <div>{{ $t("fixed-point-name") }}</div>
                <div>{{ plotItem.FIX_NAM?.split("-")?.[0] }}</div>
              </TooltipTR>
              <TooltipTR section="section1002" field="FIX_TYP" :label="$t('fixed-point-type')">
                <div>{{ $t("fixed-point-type") }}</div>
                <div>{{ plotItem.FIX_NAM?.split("-").length >= 2 ? plotItem.FIX_NAM?.split("-")?.[1] : "" }}</div>
              </TooltipTR>
              <TooltipTR section="section1002" field="FIX_DTP" :label="$t('distance-to-parcel')">
                <div>{{ $t("distance-to-parcel") }}</div>
                <div>{{ plotItem.FIX_DTP }}</div>
              </TooltipTR>
              <TooltipTR section="section1002" field="FIX_COO" :label="$t('coordinates')">
                <div>
                  {{ $t("coordinates") }}
                  <v-switch style="margin: 0px; padding: 0px" dense v-model="drawFixPoint" :label="$t('draw-fix-point')" @change="emitDrawFixPoint" />
                </div>
                <div>{{ plotItem.FIX_COO_X }} - {{ plotItem.FIX_COO_Y }}</div>
              </TooltipTR>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  contentJson: any = {}
  language
  drawFixPoint = false

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()

    const drawFixPointStorage = localStorage.getItem("draw-fix-point")
    if (drawFixPointStorage === "true") {
      this.drawFixPoint = true
      this.emitDrawFixPoint()
    }
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section1002")) || {}
  }

  emitDrawFixPoint() {
    localStorage.setItem("draw-fix-point", this.drawFixPoint ? "true" : "false")
    this.$emit("drawFixPoint", this.drawFixPoint)
  }
}
</script>
